import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=f4310048&"
import script from "./Filtro.vue?vue&type=script&lang=js&"
export * from "./Filtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports